import React from "react";
import CommonModal from "../modalLayout/CommonModal";
import { Row, Col } from "react-bootstrap";
import InputWithLabel from "../fields/InputWithLabel";
import InputWithIcon from "../fields/InputWithIcon";
import Button from "../buttons/button";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import SelectBox from "../fields/SelectBox ";
import useTranslator from "../../../hooks/useTranslator";
const AddRowMaterialModal = ({ show, handleClose, setShow }) => {
  const { _t } = useTranslator();

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title="Add/Edit Raw Material"
    >
      <Row>
        <Col lg={6}>
          <SelectBox
            label={_t("supplier_name", "Supplier Name")}
            name="supplierName"
            options={[
              { value: "john", label: "John" },
              { value: "ram", label: "Ram" },
            ]}
            required={false}
          />
        </Col>
        <Col lg={6}>
          <SelectBox
            label={_t("fruit_type", "Fruit Type")}
            name="fruittype"
            options={[
              { value: "john", label: "John" },
              { value: "ram", label: "Ram" },
            ]}
            required={false}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("batch_code", "Batch Code")}
            type="text"
            name="batchCode"
            placeholder="5"
            required={false}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("time", "Time")}
            type="text"
            name="time"
            placeholder="11:45 AM"
            required={false}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("brix_level", "Brix Level")}
            type="text"
            name="brixLevel"
            placeholder={"0"}
            required={false}
          />
        </Col>
        <Col lg={6}>
          <InputWithIcon
            label={_t("kg_entered_total", "KG Entered Total")}
            type="number"
            name="totalKg"
            placeholder={"0"}
            required={false}
            icon={RefreshSvg}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_cases_entered", "Total Cases Entered")}
            type="number"
            name="batchCode"
            placeholder={"0"}
            required={false}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <Row>
            <Col lg={6}>
              <InputWithLabel
                label={_t("palletized_cases", "Palletized Cases")}
                type="text"
                name="palletizedCases"
                placeholder={"0"}
                required={false}
                disabled={true}
              />
            </Col>
            <Col lg={6}>
              <InputWithLabel
                label={_t("not_palletized_cases", "Not Palletized Cases")}
                type="text"
                name="notPalletizedCases"
                placeholder={"0"}
                required={false}
                disabled={true}
              />
            </Col>
          </Row>
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_pallets_with_boxes", "Total pallets with 36 boxes / pallet")}
            type="text"
            name="totalPallets"
            placeholder={"0"}
            required={false}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("kg_per_case_fresh", "KG/Case Fresh")}
            type="text"
            name="greshKgCase"
            placeholder={"0"}
            required={false}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <SelectBox
            label={_t("status", "Status")}
            name="status"
            options={[
              { value: "john", label: _t("john", "John") },
              { value: "ram", label: _t("ram", "Ram") },
            ]}
            required={false}
          />
        </Col>
        <Col className="text-end" lg={6}>
          <label htmlFor="" className="opacity-0 d-block">
            {_t("invisible_label_save", "save")}
          </label>
          <Button label={_t("save_changes", "Save Changes")} size="small" />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default AddRowMaterialModal;
